<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12 px-1 py-2">
                <h1 id="page-title" class="mb-0 pb-0">
                    {{ title }}
                </h1>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  name: 'CartPageHeader',
  props: {
    title: {
      type: String,
      required: true,
    }
  }
}
</script>
